module.exports = require('./ComponentView').extend({});
